import Swiper, { Navigation, Pagination, Keyboard } from "swiper";

const sliderPartner = new Swiper(".slider-partner", {
	modules: [Navigation, Pagination, Keyboard],
	loop: true,
	spaceBetween: 40,
	threshold: 10,
	keyboard: {
		enabled: true,
		onlyInViewport: true,
	},
	pagination: {
		el: ".slider-partner-pagination",
		clickable: true,
	}
});